import { Box, Typography, Grid, Card, CardContent, List, ListItem, ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';
import { site } from '../../../config/site';
import { motion } from 'framer-motion';

import LightbulbIcon from '@mui/icons-material/LightbulbOutlined';
import SupportAgentIcon from '@mui/icons-material/SupportAgentOutlined';
import LanguageIcon from '@mui/icons-material/LanguageOutlined';
import SecurityIcon from '@mui/icons-material/SecurityOutlined';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const iconMap = {
  Lightbulb: LightbulbIcon,
  SupportAgent: SupportAgentIcon,
  Language: LanguageIcon,
  Security: SecurityIcon,
};

export default function ServicesGrid({ hideHeader = false }) {
  return (
    <Box sx={{ py: hideHeader ? 2 : 10 }}>
      {!hideHeader && (
        <>
          <Typography variant="h3" sx={{ fontWeight: 800, mb: 2, textAlign: 'center' }}>
            Nuestras <span style={{ color: '#1976d2' }}>Soluciones</span>
          </Typography>
          <Typography variant="subtitle1" sx={{ color: 'text.secondary', mb: 8, textAlign: 'center', maxWidth: 600, mx: 'auto' }}>
            Ofrecemos un portafolio integral para cubrir todas las necesidades tecnológicas de tu empresa.
          </Typography>
        </>
      )}

      <Grid container spacing={4}>
        {site.categories && site.categories.map((category, index) => {
          const Icon = iconMap[category.icon];
          const categoryServices = site.services.filter(s => s.category === category.title);

          return (
            <Grid item xs={12} md={6} key={category.title}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                style={{ height: '100%' }}
              >
                <Card 
                  elevation={0}
                  sx={{ 
                    height: '100%', 
                    background: 'linear-gradient(180deg, #0F172A 0%, #0B0F19 100%)',
                    border: '1px solid rgba(255, 255, 255, 0.05)', 
                    borderRadius: 6,
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    boxShadow: '0 20px 40px -10px rgba(0,0,0,0.1)',
                    '&:hover': {
                      boxShadow: '0 30px 60px -15px rgba(0,0,0,0.3)',
                      borderColor: 'rgba(59, 130, 246, 0.3)',
                      transform: 'translateY(-4px)'
                    }
                  }}
                >
                  <CardContent sx={{ p: { xs: 2.5, md: 3 }, display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3, gap: 2 }}>
                       {Icon && (
                         <Box sx={{ 
                           background: 'rgba(59, 130, 246, 0.1)', 
                           minWidth: '48px',
                           minHeight: '48px',
                           borderRadius: 2.5,
                           color: '#3B82F6',
                           display: 'flex',
                           alignItems: 'center',
                           justifyContent: 'center',
                           boxShadow: 'inset 0 0 0 1px rgba(59, 130, 246, 0.2)'
                         }}>
                           <Icon fontSize="medium" />
                         </Box>
                       )}
                       <Box sx={{ pt: 0.25 }}>
                         <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.2, mb: 0.5, color: '#F8FAFC', letterSpacing: '-0.01em' }}>
                           {category.title}
                         </Typography>
                         <Typography variant="body2" sx={{ color: '#94A3B8', lineHeight: 1.5, fontSize: '0.85rem' }}>
                           {category.description}
                         </Typography>
                       </Box>
                    </Box>
                    
                    <Box sx={{ 
                      flexGrow: 1, 
                      mt: 'auto', 
                      background: 'rgba(255, 255, 255, 0.02)', 
                      border: '1px solid rgba(255, 255, 255, 0.03)',
                      p: 2.5, 
                      borderRadius: 3,
                      backdropFilter: 'blur(10px)'
                    }}>
                      <Typography variant="overline" sx={{ color: '#64748B', fontWeight: 700, display: 'block', mb: 1.5, letterSpacing: '0.08em', fontSize: '0.7rem' }}>
                        SERVICIOS INCLUIDOS
                      </Typography>
                      <List disablePadding sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                        {categoryServices.map((service) => (
                          <ListItem 
                            key={service.slug}
                            disableGutters
                            component={Link}
                            to={service.path || `/servicios/${service.slug}`}
                            sx={{ 
                              color: '#CBD5E1',
                              textDecoration: 'none',
                              py: 1,
                              px: 1.5,
                              borderRadius: 1.5,
                              background: 'transparent',
                              border: '1px solid transparent',
                              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                              '&:hover': {
                                color: '#38BDF8',
                                background: 'rgba(56, 189, 248, 0.05)',
                                borderColor: 'rgba(56, 189, 248, 0.1)',
                                transform: 'translateX(4px)'
                              }
                            }}
                          >
                            <ListItemText 
                              primary={service.title} 
                              primaryTypographyProps={{ fontWeight: 500, fontSize: '0.9rem' }}
                            />
                            <ArrowForwardIosIcon sx={{ fontSize: 10, opacity: 0.5, transition: 'transform 0.3s', '&:parent:hover': { transform: 'translateX(2px)', opacity: 1 } }} />
                          </ListItem>
                        ))}
                      </List>
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}